module.exports = __webpack_public_path__ + "assets/img/daily_task_bg.a3d3ba51.png";